import React, { Component } from 'react'

export default class Textarea extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
             
        }
    }
    
    render() {
        const { placeholder,label,type, name, value ,disable,require,height,onChange,width} = this.props;
        return (
            <div className="field_row_inner">
                {label ? <label className={`${require ? 'required' : null}`}>{label} </label> :"" }
                <div className="field_input relative">
                    <textarea  name={name} onChange={onChange} value={value} style={{height:`${height ? height : "120px"}`,width:`${width ? width : "100%"}`}}>
                    </textarea>
                </div>
            </div>
        )
    }
}